import { API_GATEWAY, USER_PROFILE_CONTRACT } from '@/constants/constants'
import { useSession } from '@/context/SessionProvider'
import { MsgExecuteContractCompat } from '@ninjablaze/sdk-ts'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { UserProfileContractExecuteMsgBuilder } from './UserProfileContract.msg-builder'
import { useApolloClient } from '@apollo/client'
import { GET_USER_PROFILE } from './query'

export const requestFaucetFunds = async (address: string) => {
  const response = await fetch(`${API_GATEWAY}/faucet/faucet-create2?address=${address}`)
  return response.json()
}

export const useUpdateUserProfile = () => {
  const queryClient = useQueryClient()
  const appoloClient = useApolloClient()

  const { account, sendTransaction } = useSession()

  return useMutation({
    mutationFn: async (profile: any) => {
      const tx_result = await sendTransaction(
        MsgExecuteContractCompat.fromJSON({
          sender: account!.injectiveAddress,
          contractAddress: USER_PROFILE_CONTRACT,
          msg: UserProfileContractExecuteMsgBuilder.updateProfile({
            newProfile: {
              avatar: profile.avatar,
              user_name: profile.user_name,
            },
          }),
        })
      )

      if (tx_result?.code == 0) {
        return profile
      }

      throw Error()
    },
    onSuccess: async (newProfile) => {
      queryClient.invalidateQueries({
        queryKey: ['USER_PROFILE_ME', account?.injectiveAddress]
      })

      await appoloClient.cache.updateQuery(
        {
          query: GET_USER_PROFILE,
          variables: {
            address: account!.injectiveAddress,
          },
        },
        (data) => {
          return {
            nfts: data?.nfts || null,
            user: {
              ...data?.user,
              profileUserName: newProfile.user_name,
              profileAvatar: newProfile.avatar,
            },
          }
        }
      )
    },
  });
}
